import { render } from "./CartRows.vue?vue&type=template&id=9308e8a4"
import script from "./CartRows.vue?vue&type=script&lang=js"
export * from "./CartRows.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bertog/Code/aitmes/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__